import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { useCart } from '../../context/CartContext';
import { TruckIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
interface CartSummaryProps {
  showCheckoutButton?: boolean;
}
export function CartSummary({
  showCheckoutButton = true
}: CartSummaryProps) {
  const {
    totalItems,
    totalPrice
  } = useCart();
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('uk-UA').format(price);
  };
  const deliveryPrice = totalPrice >= 5000 ? 0 : 150;
  const finalTotal = totalPrice + deliveryPrice;
  return <div className="bg-slate-50 rounded-2xl p-6" data-id="element-57">
      <h3 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-58">
        Ваше замовлення
      </h3>

      <div className="space-y-3 text-sm" data-id="element-59">
        <div className="flex justify-between" data-id="element-60">
          <span className="text-slate-600" data-id="element-61">Товари ({totalItems})</span>
          <span className="font-medium text-slate-900" data-id="element-62">
            {formatPrice(totalPrice)} ₴
          </span>
        </div>
        <div className="flex justify-between" data-id="element-63">
          <span className="text-slate-600" data-id="element-64">Доставка</span>
          <span className="font-medium text-slate-900" data-id="element-65">
            {deliveryPrice === 0 ? <span className="text-emerald-600" data-id="element-66">Безкоштовно</span> : `${formatPrice(deliveryPrice)} ₴`}
          </span>
        </div>
        {totalPrice < 5000 && <p className="text-xs text-slate-500" data-id="element-67">
            Безкоштовна доставка від 5 000 ₴
          </p>}
      </div>

      <div className="border-t border-slate-200 mt-4 pt-4" data-id="element-68">
        <div className="flex justify-between items-baseline" data-id="element-69">
          <span className="text-base font-semibold text-slate-900" data-id="element-70">Всього</span>
          <span className="text-xl font-bold text-slate-900" data-id="element-71">
            {formatPrice(finalTotal)} ₴
          </span>
        </div>
      </div>

      {showCheckoutButton && <Link to="/checkout" className="block mt-6" data-id="element-72">
          <Button fullWidth size="lg" data-id="element-73">
            Оформити замовлення
          </Button>
        </Link>}

      {/* Trust badges */}
      <div className="mt-6 pt-6 border-t border-slate-200 space-y-3" data-id="element-74">
        <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-75">
          <TruckIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-76" />
          <span data-id="element-77">Доставка по всій Україні</span>
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-78">
          <ShieldCheckIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-79" />
          <span data-id="element-80">Офіційна гарантія</span>
        </div>
        <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-81">
          <CreditCardIcon className="w-5 h-5 text-sky-500 flex-shrink-0" data-id="element-82" />
          <span data-id="element-83">Безпечна оплата</span>
        </div>
      </div>
    </div>;
}